import { useBoolean } from './use-boolean.js';
import { useCallbackRef } from './use-callback-ref.js';
import {
  useCustomCompareEffect,
  useDeepCompareEffect,
} from './use-compare-effect.js';
import { useConst } from './use-const.js';
import { useCountdown } from './use-countdown.js';
import { useCountdownCallback } from './use-countdown-callback.js';
import {
  useDebounce,
  useDebounceCallback,
  useDebounceClick,
} from './use-debounce.js';
import { useEffectOnce } from './use-effect-once.js';
import { useForceUpdate } from './use-force-update.js';
import { useGlobal } from './use-global.js';
import { useId, useIds } from './use-id.js';
import { useInterval } from './use-interval.js';
import { useIsInitialRender } from './use-is-initial-render.js';
import { useIsMounted } from './use-is-mounted.js';
import { useLockBodyScroll } from './use-lock-body-scroll.js';
import { useModelEffect } from './use-model-effect.js';
import { useOutsideClick } from './use-outside-click.js';
import { usePrevious } from './use-previous.js';
import { useSafeLayoutEffect } from './use-safe-layout-effect.js';
import { useScrollPosition } from './use-scroll-position.js';
import { useThrottle, useThrottleCallback } from './use-throttle.js';
import { useTimeout } from './use-timeout.js';
import { useUnmountEffect } from './use-unmount-effect.js';
import { useUpdateEffect } from './use-update-effect.js';
import { useWindowEvent } from './use-window-event.js';
import { useWindowSize } from './use-window-size.js';
export const hooks = {
  useId,
  useIds,
  useBoolean,
  useTimeout,
  useInterval,
  useConst,
  useDebounce,
  useDebounceClick,
  useDebounceCallback,
  useCountdownCallback,
  useCountdown,
  useGlobal,
  useCallbackRef,
  useModelEffect,
  useForceUpdate,
  useUpdateEffect,
  useEffectOnce,
  useUnmountEffect,
  useDeepCompareEffect,
  useCustomCompareEffect,
  useSafeLayoutEffect,
  useThrottle,
  useThrottleCallback,
  useWindowSize,
  useLockBodyScroll,
  useScrollPosition,
  useWindowEvent,
  useIsMounted,
  useIsInitialRender,
  useOutsideClick,
  usePrevious,
};
